import 'mundus-agri/src/scss/products/product-list.scss';

import {
  dedereCompanyIds
} from 'application/src/js/globals.js'
import {
  ajax
} from 'application/src/js/functions.js'

import ProductGroup from './product-group.js'

/**
 * @class
 * @param {SpinnerOverlay} args.loader
 * @param {object} args.translations
 * @param {function} args.filterProductsFn
 * @param {string} args.baseTargetUrl
 * @param {boolean=} args.showNumAddresses
 */
export default class ProductList {
  constructor(args) {
    this.loader = args.loader;
    this.translations = args.translations;
    this.filterProductsFn = args.filterProductsFn;
    this.baseTargetUrl = args.baseTargetUrl;
    this.showNumAddresses = args.showNumAddresses || false;

    this.container = document.querySelector('.products-container');
    this.outerList = this.container.querySelector('.outer-list');
    this.listMenu = this.container.querySelector('.list-menu');
    this.list = this.container.querySelector('.list');
    this.searchInput = this.container.querySelector('.search-input');

    this.debugMode = true;

    this.loader.show();
    this.load()
      .then(response => {
        this.user = response.user;
        const productsData = this.trimSort(response.data);

        return this.groupProducts(
          this.canViewAllNumbers ? productsData : this.filterProductsFn(productsData)
        );
      })
      .then(productGroups => this.sortProducts(productGroups))
      .then(productGroups => {
        this.productGroups = productGroups;
        this.render(this.productGroups);
        this.addEvents();
        this.loader.hide();
      })
      .catch(e => {
        if (this.debugMode) console.log(e);
        this.loader.hide();
      });
  }

  load() {
    return ajax('/app/ajax/getProducts', {group_by_products: true});
  }

  trimSort(productsData) {
    productsData.map(product => product.name = product.name.trim());
    productsData.sort((a, b) => b.name < a.name ? 1 : -1);
    return productsData;
  }

  addEvents() {
    this.searchInput.addEventListener('input', e => {
      this.loader.show();
      this.wait()
        .then(_ => {
          const clonedProductGroups = JSON.parse(JSON.stringify(this.productGroups));
          this.render(this.filterProducts(clonedProductGroups));
          this.loader.hide();
        })
        .catch(e => {
          if (this.debugMode && e) console.log(e);
          this.loader.hide();
        });
    });
  }

  filterProducts(productGroups) {
    const searchRegexp = this.searchInput.value.trim() === '' ? /.*/ : new RegExp('.*' + this.searchInput.value.trim() + '.*', 'gi');

    return Object.values(productGroups).reduce((filteredGroups, group) => {
      const products = group.products.reduce((filteredProducts, product) => {
        if (product.name.match(searchRegexp) !== null) filteredProducts.push(product);
        return filteredProducts;
      }, []);

      group.products = products;

      if (group.products.length) filteredGroups[group.headline] = group;
      return filteredGroups;
    }, {});
  }

  wait() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    return new Promise((resolve, reject) => {
      this.searchTimeout = setTimeout(_ => resolve(), 250);
    });
  }

  groupProducts(products) {
    return products.reduce((aggregated, product) => {
      const firstLetter = product.name.substr(0, 1).toUpperCase();
      if (aggregated[firstLetter]) {
        aggregated[firstLetter].products.push(product);
      } else {
        aggregated[firstLetter] = {
          headline: firstLetter,
          products: [product]
        }
      }
      return aggregated;
    }, {});
  }

  sortProducts(productGroups) {
    Object.values(productGroups).map(group => {
      group.products.sort((a, b) => a.name.toLowerCase() > a.name.toLowerCase() ? -1 : 1);
    });

    return productGroups;
  }

  render(productGroups) {
    this.list.innerHTML = '';
    this.listMenu.innerHTML = '';

    Object.keys(productGroups).map(firstLetter => {
      this.listMenu.insertAdjacentHTML('beforeend', `
        <a href="#${firstLetter}">${firstLetter}</a>
      `);
    });

    Object.values(productGroups).map(groupData => {
      const productGroupElement = document.createElement('div');
      this.list.insertAdjacentElement('beforeend', productGroupElement);

      new ProductGroup({
        parent: this,
        user: this.user,
        element: productGroupElement,
        data: groupData,
        translations: this.translations,
        baseTargetUrl: this.baseTargetUrl
      });
    });
  }

  get canViewAllNumbers() {
    return this.user && dedereCompanyIds.indexOf(this.user.company_id) > 0;
  }

  get canViewNumAddresses() {
    return this.showNumAddresses;
  }
}